import auth from '../../../config/app-specific-config/auth';
import * as types from './global-actions-types';
import { axiosInstance } from '../../../config/app-specific-config/axiosConfig';

export const setIsMobileView = (p) => {
	return {
		type: types.SET_IS_MOBILE_VIEW,
		payload: p
	};
};

export const setIsShrunkHeader = (p) => {
	return {
		type: types.SET_IS_SHRUNK_HEADER,
		payload: p
	};
};

export const setIsLockedRoom = (p) => {
	return {
		type: types.SET_IS_LOCKED_ROOM,
		payload: p
	};
};

export const setLockedRoomLiveMetadata = (p) => {
	return {
		type: types.SET_LOCKED_ROOM_LIVE_METADATA,
		payload: p
	};
};

export const setDeepModalTransferPayload = (p) => {
	return {
		type: types.SET_DEEP_MODAL_TRANSFER_PAYLOAD,
		payload: p
	};
};

export const resetDeepModalTransferPayload = (p) => {
	return {
		type: types.RESET_DEEP_MODAL_TRANSFER_PAYLOAD,
		payload: p
	};
};

export const sendSystemNotificationEmailSuccess = (response) => {
	return {
		type: types.SEND_SYSTEM_NOTIFICATION_EMAIL_SUCCESS,
		payload: response.data
	};
};

export const sendSystemNotificationEmailFailure = (error) => {
	return {
		type: types.SEND_SYSTEM_NOTIFICATION_EMAIL_FAILURE,
		error
	};
};

export const sendSystemNotificationEmailRequest = () => {
	return {
		type: types.SEND_SYSTEM_NOTIFICATION_EMAIL_REQUEST
	};
};

export function sendSystemNotificationEmail(submittedContent) {
	
	return async (dispatch) => {
		dispatch(sendSystemNotificationEmailRequest());
		try {
			const url = '/emailer/internal-notification-email';
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.post(url, submittedContent, { headers });

			dispatch(sendSystemNotificationEmailSuccess(response));
		} catch (error) {
			dispatch(sendSystemNotificationEmailFailure(error));
		}
	};
}


export const unlockRoomSuccess = (response) => {
	return {
		type: types.UNLOCK_ROOM_SUCCESS,
		payload: response.data
	};
};

export const unlockRoomFailure = (error) => {
	return {
		type: types.UNLOCK_ROOM_FAILURE,
		error
	};
};

export const unlockRoomRequest = () => {
	return {
		type: types.UNLOCK_ROOM_REQUEST
	};
};

export function unlockRoom(unlockRoomMetadata) {
	
	return async (dispatch) => {
		dispatch(unlockRoomRequest());
		try {
			const url = '/dsr/unlock-room';
			const headers = await auth.getAccessToken();
			const response = await axiosInstance.post(url, unlockRoomMetadata, { headers });

			dispatch(unlockRoomSuccess(response));
		} catch (error) {
			dispatch(unlockRoomFailure(error));
		}
	};
}